const images = {
  en_logo: require('./logo_en.png'),
  default_blank_image: require('./default_blank_image.png'),
  intro: {
    patient1: require('./intro/patient1.png'),
    patient2: require('./intro/patient2.png'),
    patient3: require('./intro/patient3.png'),
    doctor1: require('./intro/doctor1.png'),
    doctor2: require('./intro/doctor2.png'),
    doctor3: require('./intro/doctor3.png'),
  },
  features: {
    feature1: require('./features/feature1.png'),
    feature3: require('./features/feature3.png'),
  },
  tabs: {
    home: require('./tabs/home_icon.png'),
    home_focused: require('./tabs/home_icon_focused.png'),
    history: require('./tabs/visit_history_icon.png'),
    history_focused: require('./tabs/visit_history_icon_focused.png'),
    others: require('./tabs/others_icon.png'),
    others_focused: require('./tabs/others_icon_focused.png'),
  },
  home_logo: require('./home_logo.png'),
  support: require('./support.png'),
  doctors_list_icon: require('./doctors_list_icon.png'),
  answer_call: require('./answer_call_icon.png'),
  hang_up: require('./hangup_call_icon.png'),
  attachment: require('./attachment.png'),
  send: require('./send.png'),
  chat_bg: require('./wallpaper.avif'),
  pdf: require('./pdf.png'),
  transaction_setting: require('./transaction_setting.png'),
  logout: require('./logout.png'),
  response_time_setting: require('./response_time_setting.png'),
  survey: require('./survey.png'),
  deposit: require('./deposit.png'),
  withdrawal: require('./withdrawal.png'),
  logo: require('../../../public/icon-1024.png'),
  settlement: require('./settlement.png'),
};

export { images };
